// Typed access to the Vite env. Getters read `import.meta.env` lazily so values
// can be stubbed in tests (vi.stubEnv).
export const env = {
  get rivendellBaseUrl(): string {
    return import.meta.env.VITE_RIVENDELL_BASE_URL ?? '';
  },
  get prismAllowedOrigins(): string[] {
    return (import.meta.env.VITE_PRISM_ALLOWED_ORIGINS ?? '')
      .split(',')
      .map((o) => o.trim())
      .filter(Boolean);
  },
  get devToken(): string | undefined {
    return import.meta.env.VITE_PRISM_OPTIID_ACCESS_TOKEN || undefined;
  },
  get devOrgId(): string | undefined {
    return import.meta.env.VITE_PRISM_ORG_ID || undefined;
  },
  // Gates PR-lane routing (parity with zip-directory). Off unless explicitly 'true'.
  get prLaneEnabled(): boolean {
    return import.meta.env.VITE_PR_LANE_ENABLED === 'true';
  },
};
